import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import { compose, branch, withProps, renderComponent, renderNothing } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'

import { GLOBAL_ROLES } from 'containers/Role/constants'
import { POST_APPROVALS, GREENLIGHT_STATES } from './constants'

import ProgressBar from './ProgressBar'
import {
  enhance as withRoles
} from 'containers/Role/Hide/AnyGlobalRoles'

import { loading } from 'containers/Async/index'
import Button from './Button'
import Dropdown from './Dropdown'
import Chip from './Chip'
import Switch from './Switch'
import Body1 from 'components/typography/body1/index'

import styles from './styles.scss'
import notifyHoc from 'containers/App/Notification/Notify'

const withStyle = CSSModules(styles)

const ClientApproval = branch(
  ({ status }) => status === GREENLIGHT_STATES.PENDING,
  renderNothing
)(Chip)

const Approval = ({onAccept, onReject, value, label}) => {
  return (
    <Flex
      align='center'
      justify='flex-end'
    >
      <div styleName='approvalLabel'>
        <span>
          { label }
        </span>
      </div>
      <Button
        label='Accept'
        primary
        raised
        onClick={onAccept}
      />
      <Button
        label='Reject'
        accent
        raised
        onClick={onReject}
      />
    </Flex>
  )
}

const enhance = compose(
  withProps({
    roles: [
      GLOBAL_ROLES.CLIENT_ACCESS,
      // GLOBAL_ROLES.ADMIN_ACCESS,
    ]
  }),
  withRoles(ClientApproval),
  branch(
    ({ status }) => !status,
    renderNothing
  ),
  branch(
    ({ status }) => status !== GREENLIGHT_STATES.PENDING,
    renderComponent(Chip)
  ),
  notifyHoc,
  withStyle
)

const EnhancedApproval = enhance(Approval)

const GreenlightRevision = props => {
  const {
    source,
    onAccept,
    onReject,
    onChange,
    value,
    approved
  } = props

  return (
    <Flex
      styleName='revision'
      align='center'
      justify='flex-end'
    >
      <EnhancedApproval
        value={value}
        status={approved}
        onAccept={onAccept}
        onReject={onReject}
        message={T.translate('pages.project.view.notification.approve', {revision: value})}
      />
      <Dropdown
        source={source}
        value={value}
        onChange={onChange}
      />
    </Flex>
  )
}

export default withStyle(GreenlightRevision)
